import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from 'src/app/components/icon/icon.module';
import { FormFieldModule } from 'src/app/components/form-field/form-field.module';
import { DialogModule } from '../dialog/dialog.module';
import { InputModule } from 'src/app/components/input/input.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { QrCodeSecretDialogComponent } from './qr-code-secret-dialog.component';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [QrCodeSecretDialogComponent],
  exports: [QrCodeSecretDialogComponent],
  imports: [
    CdkDrag,
    CdkDragHandle,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormFieldModule,
    InputModule,
    DialogModule,
    ProgressSpinnerModule,
    IconModule,
    ButtonModule,
  ],
})
export class QrCodeSecretDialogModule {}
